import {CommonModule, DatePipe} from '@angular/common';
import {ChangeDetectorRef, Component, HostListener, Inject, OnInit,} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedFeaturesService} from 'src/app/services/shared-features.service';
import {ShowDialogsComponent} from 'src/app/components/show-dialogs/show-dialogs.component';
import {SolutionConfigurationFormComponent} from '../solution-configuration-form/solution-configuration-form.component';
import {SolutionExecutorFormComponent} from '../solution-executor-form/solution-executor-form.component';
import {NewVersionDialogComponent} from '../new-version-dialog/new-version-dialog.component';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef,} from '@angular/material/dialog';
import {JobSchedulerComponent} from 'src/app/components/job-scheduler/job-scheduler.component';
import {firstValueFrom, Observable} from 'rxjs';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SolutionsAppService} from 'src/app/services/solutions-app.service';

@Component({
  selector: 'app-solutions-versions',
  template: `
    <div class="engine-page">
      <div class="content">
        <!-- breadcrumb -->
        <div class="crumbs">
          <a routerLink="/home/manage-solutions/mySolutions">My Solutions</a>
          <span class="sep">›</span>
          <span class="cur" [matTooltip]="activeSolution?.solution_name">{{
            activeSolution?.solution_name | namingsize : 55
          }}</span>
        </div>

        <!-- header -->
        <div class="engine-head">
          <div class="eh-ico">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor"
                 stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="13" rx="2" />
              <path d="M8 21h8M12 17v4" />
            </svg>
          </div>
          <div class="eh-mid">
            <h1 [matTooltip]="activeSolution?.solution_name">
              {{ activeSolution?.solution_name | namingsize : 45 }}
            </h1>
            <p>
              {{ availableVersions?.length || 0 }}
              {{ availableVersions?.length === 1 ? 'version' : 'versions' }}
            </p>
          </div>
          <button class="btn-primary" (click)="createNewVersion(activeSolution)">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
                 stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 5v14M5 12h14" />
            </svg>
            New version
          </button>
        </div>

        <!-- versions -->
        <mat-accordion class="ver-acc" multi>
          <mat-expansion-panel
            *ngFor="let version of availableVersions"
            (opened)="getAvailableFormData(version['version_id'])"
          >
            <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
              <mat-panel-title>
                <div class="vh">
                  <span class="vbadge">{{ version.version_name }}</span>
                  <span class="vstage" [ngClass]="stageClass(version.stage)">{{
                    stageLabel(version.stage)
                  }}</span>
                  <span class="vmeta">
                    {{ version.version_owner }} ·
                    {{ version.updated_dtm | date : 'dd MMM yyyy' }}
                  </span>
                </div>
              </mat-panel-title>
              <span class="vh-actions">
                <span
                  class="iconbtn form"
                  matTooltip="{{ versionFormMap[version['version_id']] ? 'Edit configuration form' : 'Create configuration form' }}"
                  (click)="$event.stopPropagation(); createForm(version)"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                       stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <path d="M14 2v6h6" /><path d="M8 13h8M8 17h5" />
                  </svg>
                  <span class="form-dot" *ngIf="versionFormMap[version['version_id']]"></span>
                </span>
                <span
                  class="iconbtn"
                  [class.is-disabled]="!versionFormMap[version['version_id']]"
                  matTooltip="Preview configuration form"
                  (click)="
                    $event.stopPropagation();
                    versionFormMap[version['version_id']] && previewForm(version)
                  "
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                       stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z" /><circle cx="12" cy="12" r="3" />
                  </svg>
                </span>
                <span
                  class="iconbtn"
                  matTooltip="Run this version"
                  (click)="$event.stopPropagation(); runVersion(version)"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" stroke="none">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </span>
                <span
                  class="iconbtn danger"
                  matTooltip="Delete version"
                  (click)="$event.stopPropagation(); deleteVersion(version)"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                       stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M6 6l1 14h10l1-14" />
                  </svg>
                </span>
              </span>
            </mat-expansion-panel-header>

            <!-- body -->
            <div class="ver-body">
              <div class="vb-bar">
                <span class="vb-lbl">Projects</span>
                <div class="vb-actions">
                  <button class="btn-ghost-sm" (click)="addProject(version)">
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                         stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 5v14M5 12h14" />
                    </svg>
                    Add project
                  </button>
                  <button class="btn-ghost-sm" (click)="updateExecutionOrder(version)">
                    Save order
                  </button>
                </div>
              </div>

              <div
                class="proj-list"
                cdkDropList
                (cdkDropListDropped)="drop($event, version['version_id'])"
              >
                <div
                  class="proj-row"
                  cdkDrag
                  *ngFor="
                    let project of availableProjects[version['version_id']];
                    let i = index
                  "
                  [cdkDragData]="project"
                >
                  <div class="proj-ph" *cdkDragPlaceholder></div>
                  <span class="pr-handle" cdkDragHandle matTooltip="Drag to reorder">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" stroke="none">
                      <circle cx="9" cy="6" r="1.6" /><circle cx="15" cy="6" r="1.6" />
                      <circle cx="9" cy="12" r="1.6" /><circle cx="15" cy="12" r="1.6" />
                      <circle cx="9" cy="18" r="1.6" /><circle cx="15" cy="18" r="1.6" />
                    </svg>
                  </span>
                  <span class="pr-ord">{{ i + 1 }}</span>
                  <a
                    class="pr-name"
                    [routerLink]="
                      version && project
                        ? [version.version_id, project.project_id, 'configurePipeline']
                        : null
                    "
                    >{{ project['project_name'] }}</a
                  >
                  <span class="pr-when">{{
                    project['created_dtm'] | date : 'dd MMM yyyy'
                  }}</span>
                  <span
                    class="iconbtn"
                    matTooltip="Run"
                    (click)="
                      runProject(version, project['project_id'], project['project_name'])
                    "
                  >
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" stroke="none">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </span>
                  <span
                    class="iconbtn danger"
                    matTooltip="Delete"
                    (click)="deleteProject(project['project_id'], version)"
                  >
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                         stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M6 6l1 14h10l1-14" />
                    </svg>
                  </span>
                </div>

                <div
                  class="proj-empty"
                  *ngIf="!availableProjects[version['version_id']]?.length"
                >
                  No projects yet — add one to start building the pipeline.
                </div>
              </div>

              <app-version-documentation
                [solutionId]="activeSolution?.solution_id"
                [versionId]="version['version_id']"
                [solutionName]="activeSolution?.solution_name"
                [versionName]="version['version_name']"
              ></app-version-documentation>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="ver-empty" *ngIf="availableVersions && !availableVersions.length">
          No versions yet — create your first version to begin.
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./solutions-versions.component.scss'],
})
export class SolutionsVersionsComponent implements OnInit {
  activeSolution: any;
  solutionId: string | any = '';
  availableVersions: any;
  availableProjects: any = {};
  testingSteps = [
    {
      key: 'Ready for Test',
      stage: 'staging',
      action: 'updateStage',
    },
    {
      key: 'Deploy on Staging',
      stage: 'approved_for_production',
      action: null,
    },
    {
      key: 'Send For Approval',
      stage: 'production',
      action: null,
    },
  ];
  versionFormAvailable: boolean = false;
  formData: any;
  versionFormMap: { [versionId: string]: boolean } = {};
  formDataMap: { [versionId: string]: any } = {};
  unsavedChanges: boolean = false;

  constructor(
    private solutionServices: SolutionsAppService,
    private datePipe: DatePipe,
    private router: Router,
    private snackBar: SharedFeaturesService,
    private activeRoute: ActivatedRoute,
    private dialog: MatDialog,
    private detectChange: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.solutionId = this.activeRoute.snapshot.paramMap.get('solutionId');
    this.solutionServices
      .getAvailableSolution({solution_id: this.solutionId})
      .subscribe({
        next: (response: any) => {
          this.activeSolution = response;
          if (!this.activeSolution.solution_id) {
            this.router.navigate(['../']);
          }
          this.refreshVersion();
        },
        error: (error: any) => {
          console.error('encountered an error', error);
          this.router.navigate(['../']);
        },
      });
  }

  stageLabel(stage: string): string {
    switch (stage) {
      case 'staging':
        return 'Draft';
      case 'approved_for_production':
        return 'Approved';
      case 'production':
        return 'Live';
      default:
        return (stage || '').replace(/_/g, ' ');
    }
  }

  stageClass(stage: string): string {
    switch (stage) {
      case 'production':
        return 'st-green';
      case 'approved_for_production':
        return 'st-blue';
      default:
        return 'st-amber';
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.unsavedChanges) {
      return confirm('You have unsaved changes. Do you really want to leave?');
    }
    return true;
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.unsavedChanges) {
      $event.returnValue = true;
    }
  }

  openScheduler() {
    const versionDialogRef = this.dialog.open(JobSchedulerComponent, {
      disableClose: false,
      panelClass: 'job-scheduler-dialog',
    });
    versionDialogRef.afterClosed().subscribe((selection) => {
      if (selection) {
      }
    });
  }

  refreshVersion() {
    this.solutionServices.getAvailableVersion(this.activeSolution).subscribe({
      next: (response: any) => {
        this.availableVersions = response.sort(
          (a: any, b: any) =>
            parseInt(b?.version_name.substr(1)) -
            parseInt(a?.version_name.substr(1))
        );
        this.prepareAvailableProjectsForVersion();
      },
    });
  }

  prepareAvailableProjectsForVersion() {
    for (const version of this.availableVersions) {
      this.getProjects(version);
      this.getAvailableFormData(version['version_id']);
    }
  }

  getProjects(version: any) {
    this.solutionServices
      .getProjectsInVersion(this.activeSolution, version)
      .subscribe({
        next: (response: any) => {
          response.sort(
            (a: any, b: any) => a.execution_order_id - b.execution_order_id
          );
          this.availableProjects[version['version_id']] = response;
        },
        error: (error: any) => {
          console.error('Error fetching projects:', error);
        },
      });
  }

  executeMethod(methodName: any, params: any[]) {
    if (methodName == 'updateStage') {
      this.updateStage(params[0], params[1]);
    } else {
      this.snackBar.openSnackBar(
        'this feature is not ready yet',
        'Close',
        'success-snackbar'
      );
    }
  }

  updateStage(version: any, stage: any) {
    const versionDialogRef = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Change stage',
        message: 'Confirm stage change to QA?',
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        danger: false,
      },
      disableClose: false,
    });
    versionDialogRef.afterClosed().subscribe((selection) => {
      if (selection) {
        version['stage'] = stage;
        this.solutionServices
          .updateVersion(version, this.activeSolution)
          .subscribe({
            next: (response: any) => {
              this.snackBar.openSnackBar(
                'stage changes successfully',
                'Close',
                'success-snackbar'
              );
            },
            error: (error: any) => {
              this.snackBar.openSnackBar(
                error.error['msg'],
                'Close',
                'error-snackbar'
              );
            },
          });
      }
    });
  }

  createNewVersion(version: any) {
    const versionDialogRef = this.dialog.open(NewVersionDialogComponent, {
      width: '600px',
      maxWidth: '94vw',
      panelClass: 'nvd-panel',
      disableClose: false,
      data: {solution: this.activeSolution},
    });
    versionDialogRef.afterClosed().subscribe((selection) => {
      if (selection) {
        if (selection === 'New') {
          this.solutionServices
            .createVersion(version, this.activeSolution)
            .subscribe({
              next: (response: any) => {
                this.snackBar.openSnackBar(
                  `version ${response.version_name} created`,
                  'Close',
                  'success-snackbar'
                );
                this.refreshVersion();
              },
              error: (error) => {
                this.snackBar.openSnackBar(
                  error.message,
                  'Close',
                  'error-snackbar'
                );
              },
            });
        } else {
          this.solutionServices
            .createVersionFromExistingVersion(
              this.activeSolution,
              version,
              selection
            )
            .subscribe({
              next: (response: any) => {
                this.snackBar.openSnackBar(
                  'version created successfully',
                  'Close',
                  'success-snackbar'
                );
                this.refreshVersion();
              },
              error: (error) => {
                this.snackBar.openSnackBar(
                  this.snackBar.convertErrorToString(error?.error),
                  'Close',
                  'error-snackbar'
                );
              },
            });
        }
      }
    });
  }

  addProject(version: any) {
    this.router.navigate([
      '/home/manage-solutions/mySolutions/' +
      this.activeSolution?.solution_id +
      '/' +
      version.version_id +
      '/configureProject',
    ]);
  }

  deleteVersion(version: any) {
    const dialogRef = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Delete version',
        message: `Delete '${version.version_name}'? This permanently removes the version and its projects.`,
        confirmText: 'Delete',
        danger: true,
      },
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.solutionServices
          .deleteVersion(version, this.activeSolution)
          .subscribe({
            next: (response: any) => {
              this.refreshVersion();
              this.snackBar.openSnackBar(
                `version ${version.version_name} deleted successfully`,
                'Close',
                'success-snackbar'
              );
            },
            error: (error: any) => {
              this.snackBar.openSnackBar(
                error['msg'],
                'Close',
                'error-snackbar'
              );
            },
          });
      }
    });
  }

  deleteProject(projectId: string, version: any) {
    const dialogRef = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Delete project',
        message: 'Delete this project? This permanently removes it and its pipeline.',
        confirmText: 'Delete',
        danger: true,
      },
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.solutionServices
          .deleteProject(this.activeSolution, version, projectId)
          .subscribe({
            next: (result: any) => {
              this.snackBar.openSnackBar(
                'project deleted successfully',
                'Close',
                'success-snackbar'
              );
              this.getProjects(version);
            },
            error: (error: any) => {
              this.snackBar.openSnackBar(
                error['msg'],
                'Close',
                'error-snackbar'
              );
            },
          });
      }
    });
  }

  runProject(version: any, projectId: string, projectName: string) {
    let data = {
      project_ids: [projectId],
      pipeline_ids: [],
      node_ids: [],
      tags: [],
    };
    this.snackBar.openSnackBar(
      `Starting "${projectName}"…`,
      'Close',
      'progress-snackbar'
    );
    this.solutionServices
      .runVersionOrProjectOrPipelineOrNode(
        this.activeSolution?.solution_id,
        version?.version_id,
        data
      )
      .subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            `"${projectName}" started${response?.task_id ? ` (task #${String(response.task_id).slice(0, 8)})` : ''} — we'll let you know when it finishes.`,
            'Close',
            'success-snackbar'
          );
        },
        error: (error) => {
          this.snackBar.openSnackBar(
            error.error.error,
            'Close',
            'error-snackbar'
          );
        },
      });
  }

  runVersion(version: any) {
    let temp = {
      project_ids: [],
      pipeline_ids: [],
      node_ids: [],
      tags: [],
    };
    const runLabel = version?.version_name
      ? `${version.version_name} of "${this.activeSolution?.solution_name}"`
      : 'version run';
    this.snackBar.openSnackBar(
      `Starting ${runLabel}…`,
      'Close',
      'progress-snackbar'
    );
    this.solutionServices
      .runVersionOrProjectOrPipelineOrNode(
        this.activeSolution?.solution_id,
        version?.version_id,
        temp
      )
      .subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            `Started ${runLabel}${response?.task_id ? ` (task #${String(response.task_id).slice(0, 8)})` : ''} — we'll let you know when it finishes.`,
            'Close',
            'success-snackbar'
          );
        },
        error: (error: any) => {
          this.snackBar.openSnackBar(
            error.error.error,
            'Close',
            'error-snackbar'
          );
        },
      });
  }

  createForm(version: any) {
    const formDialogRef = this.dialog.open(SolutionConfigurationFormComponent, {
      data: {
        formData: this.formDataMap[version['version_id']],
        solution: this.activeSolution,
        version: version,
      },
      width: '96vw',
      maxWidth: '1500px',
      height: '92vh',
      panelClass: 'config-form-dialog',
      disableClose: true,
    });

    formDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.info('Submit');
      }
      this.getAvailableFormData(version['version_id']);
      this.detectChange.detectChanges();
    });
  }

  previewForm(version: any) {
    const formDialogRef = this.dialog.open(SolutionExecutorFormComponent, {
      data: {
        formData: this.formDataMap[version['version_id']],
        subscriptionDetails: {...this.activeSolution, ...version},
        preview: true,
      },
      panelClass: 'executor-form-dialog',
      disableClose: false,
    });
    formDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.info('Submit');
      }
      this.detectChange.detectChanges();
    });
  }

  getAvailableFormData(versionId: string) {
    this.solutionServices
      .getForm(this.activeSolution, {version_id: versionId})
      .subscribe({
        next: (response: any) => {
          if (!response.length) {
            this.versionFormMap[versionId] = false;
            this.formDataMap[versionId] = undefined;
          } else {
            this.versionFormMap[versionId] = true;
            this.formDataMap[versionId] = response[0];
          }
          // keep single-value fields in sync for the most-recently-touched version
          this.versionFormAvailable = this.versionFormMap[versionId];
          this.formData = this.formDataMap[versionId];
        },
      });
  }

  drop(event: CdkDragDrop<any[]>, versionId: string) {
    this.unsavedChanges = true;
    const previousIndex = event.previousIndex;
    const newIndex = event.currentIndex;
    moveItemInArray(this.availableProjects[versionId], previousIndex, newIndex);

    const projects = this.availableProjects[versionId];
    projects.forEach((project: any, index: number) => {
      project.execution_order_id = index + 1;
    });
  }

  async updateExecutionOrder(version: any) {
    const projects = this.availableProjects[version?.version_id];
    let projectUpdated = '';
    let projectFailed = '';
    if (projects) {
      for (const project of projects) {
        try {
          const response = await firstValueFrom(
            this.solutionServices.updateProject(
              this.activeSolution,
              version,
              project,
              project?.project_id
            )
          );

          projectUpdated += `  ${project.project_name}`;
          console.info('Updated order', JSON.stringify(response));
        } catch (error) {
          projectFailed += `  ${project.project_name}`;
          console.error('An error occurred', JSON.stringify(error));
        }
      }

      if (!projectFailed) {
        this.snackBar.openSnackBar(
          `Projects order updated: ${projectUpdated}`,
          'Close',
          'success-snackbar'
        );
      } else {
        this.snackBar.openSnackBar(
          `Unable to update the order: ${projectFailed}`,
          'Close',
          'error-snackbar'
        );
      }
      this.unsavedChanges = false;
    }
  }
}
